import 'core_ext/index.js';

window.Skylark = {};

import App from 'app/index.js';
Skylark.App = App;

import Libs from 'libs/index.js';
window.CurrentAttributes = Libs.CurrentAttributes;
window.DomMaster         = Libs.DomMaster;

delete Libs.CurrentAttributes;
delete Libs.DomMaster;
Skylark.Libs = Libs;

import Helpers from 'helpers/index.js';
Skylark.Helpers = Helpers;
